import { config } from 'src/lib/config';
import { AbstractService } from './AbstractService';

export interface MerchantOrchestrationContextualStatus {
    status: string;
    context?: {
        Country?: string;
        Merchant?: string;
    };
}

export interface MerchantOrchestrationResponse {
    contextualStatus?: MerchantOrchestrationContextualStatus[];
}

export class MerchantOrchestrationService extends AbstractService {
    static async getAvailableLocales(
        accessToken: string,
        productKey: string,
        productVersion: number,
    ): Promise<string[]> {
        const service = new MerchantOrchestrationService({
            ...config.services.merchantOrchestrationServiceApi,
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        });

        try {
            const response = await service.api.get(`${service.version}/products/${productKey}/versions/${productVersion}`).json<MerchantOrchestrationResponse>();

            if (!response?.contextualStatus) {
                return [];
            }

            return response.contextualStatus
                .filter((cs) => cs.status === 'ACTIVE'
                        && cs.context?.Country
                        && cs.context?.Merchant === 'VISTAPRINT').map((cs) => cs.context!.Country!)
                .filter((country, index, array) => array.indexOf(country) === index);
        } catch (error) {
            console.error(`Failed to fetch product cultures for Product: ${productKey}, Version: ${productVersion} from Merchant Orchestration API.`, error);
            return [];
        }
    }
}
